import clsx from "clsx";
import { FlagIcon } from "./FlagIcon";
import styles from "./UserNotificationIndicator.module.scss";

interface Props {
  count?: number;
  // Supplementary document rows fan the flags downward (and from a different
  // pivot point) so the indicator sits cleanly inside the row.
  isSupplement?: boolean;
}

const FLAG_WIDTH = 22;
const FLAG_HEIGHT = 10;

export function UserNotificationIndicator(props: Props) {
  const count = props.count ?? 1;
  const isSupplement = props.isSupplement ?? false;

  return (
    <div className={styles.container}>
      <FlagIcon
        width={FLAG_WIDTH}
        height={FLAG_HEIGHT}
        rotate={320}
        className={clsx(styles.flagFirst, isSupplement && styles.flagFirstDown)}
      />
      {count > 1 && (
        <FlagIcon
          width={FLAG_WIDTH}
          height={FLAG_HEIGHT}
          rotate={332}
          className={isSupplement ? styles.flagSecondDown : styles.flagSecondUp}
        />
      )}
      {count > 2 && (
        <FlagIcon
          width={FLAG_WIDTH}
          height={FLAG_HEIGHT}
          rotate={344}
          className={isSupplement ? styles.flagThirdDown : styles.flagThirdUp}
        />
      )}
    </div>
  );
}
